import type { AppTranslations } from 'translations/translations';

export const getSnapshotSize = (
  snapshotSettingsMsg: AppTranslations['snapshotManagement'],
  size: number | null | undefined,
): string =>
  size
    ? `${(Number(size) / (1024 * 1024)).toFixed(2)} MB`
    : snapshotSettingsMsg.notAvailable;
